import type { ObjectMapping } from '@shared/types/utils';

import { FILTER_TYPE } from '@shared/utils-frontend/mini-events/constants';

export const BASE_ROOM_TYPE: ObjectMapping = {
  ROOM_FILTER_OPTION_ROOM_TYPE_UNSET_ROOM: 'UNSET_ROOM_TYPE',
  ROOM_FILTER_OPTION_ROOM_TYPE_SINGLE_ROOM: 'SINGLE_ROOM',
  ROOM_FILTER_OPTION_ROOM_TYPE_DOUBLE_ROOM: 'DOUBLE_ROOM',
  ROOM_FILTER_OPTION_ROOM_TYPE_TWIN_ROOM: 'TWIN_ROOM',
  ROOM_FILTER_OPTION_ROOM_TYPE_TRIPLE_ROOM: 'TRIPLE_ROOM',
  ROOM_FILTER_OPTION_ROOM_TYPE_FAMILY_ROOM: 'FAMILY_ROOM',
  ROOM_FILTER_OPTION_ROOM_TYPE_SUITE_ROOM: 'SUITE_ROOM',
};

export const OFFER_FILTER_TYPE: ObjectMapping = {
  free_cancellation: 'is_free_cancellation_selected',
  breakfast_included: 'is_breakfast_included_selected',
};

export const RATE_LAYOUT_TYPE: ObjectMapping = {
  UNSET_RATE_LAYOUT_TYPE: 'UNSET_RATE_LAYOUT_TYPE',
  ONLY_META: 'ONLY_META',
  ONLY_DBOOK: 'ONLY_DBOOK',
  META_AND_DBOOK: 'META_AND_DBOOK',
};

export const REVIEW_FILTER_TYPE_MAPPING: ObjectMapping = {
  guestType: FILTER_TYPE.GUEST_TYPE,
  filterLocale: FILTER_TYPE.LOCALE,
  sort: FILTER_TYPE.SORT_TYPE,
  allTag: FILTER_TYPE.TAG,
  image: FILTER_TYPE.TAG,
  tags: FILTER_TYPE.TAG,
  dataSource: FILTER_TYPE.REVIEW_PROVIDER,
  guestRating: FILTER_TYPE.GUEST_RATING,
  travellerRating: FILTER_TYPE.GUEST_RATING,
};

export const UBFF_REVIEW_FILTER_TYPE_MAPPING: ObjectMapping = {
  FILTER_TYPE_GUEST_TYPE: FILTER_TYPE.GUEST_TYPE,
  FILTER_TYPE_LOCALE: FILTER_TYPE.LOCALE,
  FILTER_TYPE_TAG: FILTER_TYPE.TAG,
  FILTER_TYPE_DATA_SOURCE: FILTER_TYPE.REVIEW_PROVIDER,
  FILTER_TYPE_TRAVELLER_RATING: FILTER_TYPE.GUEST_RATING,
  FILTER_TYPE_SORT: FILTER_TYPE.SORT_TYPE,
};
